import Pristine from 'pristinejs/dist/pristine';
import { SENDEMAIL_SERVICE } from '../services/sendEmailService';

const HANDLES = {
    init() {
        this.contactForm();
    },
    contactForm() {
        const form = document.getElementById('ao__book-a-demo-form');
        if (form === null) return;

        const pristine = new Pristine(form, {
            classTo: 'ao-field',
            errorClass: 'ao-field--error',
            successClass: 'ao-field--success',
            errorTextParent: 'ao-field',
            errorTextTag: 'div',
            errorTextClass: 'ao-error',
        });
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            if (!pristine.validate()) return;
            form.querySelector('button[type="submit"]').classList.add('is-loading');
            return SENDEMAIL_SERVICE.sendEmail(form);
        });
    },
};

export { HANDLES };
